import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { ActivityDetailResponse, GetActivitiesPaginatedResponse } from '../domain/activity.model';
import { ActivityRepository } from './activity.repository';

@Injectable()
export class ActivityApiService implements ActivityRepository {
    private _http = inject(HttpClient);

    getActivityDetail(id: string): Observable<ActivityDetailResponse> {
        return this._http.get<ActivityDetailResponse>(`${environment.url}${MICROSERVICES.activities}/activities/${id}`);
    }
    listVehicleActivities(page = 1, pageSize = 30, type: string | null, status: string | null): Observable<GetActivitiesPaginatedResponse> {
        const params = new HttpParams().set('page', page).set('size', pageSize);
        if (type) {
            params.set('type', type);
        }
        if (status) {
            params.set('status', status);
        }
        const options = {
            params,
        };
        return this._http.get<GetActivitiesPaginatedResponse>(`${environment.url}${MICROSERVICES.activities}/activities`, options);
    }
}
